import { useState } from "react";
import { Button, Form, Input, message } from "antd";
import {
  FileTextOutlined,
  CheckCircleOutlined,
  QuestionCircleOutlined,
  FormOutlined,
  BarChartOutlined,
  EditOutlined,
} from "@ant-design/icons";

import { LoginTypes } from "src/static/interface";
import LottieAnimation from "src/components/lottie";
import { Link } from "react-router-dom";
import { rules } from "src/static/rules";
import { SignInAdminConfig } from "src/service/api/open";
import { handleLoginFunc } from "src/utils";

function AdminLoginPage() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (val: LoginTypes) => {
    setLoading(true);
    SignInAdminConfig(val)
      .then((res) => {
        handleLoginFunc(res.data.object);
      })
      .catch((err) => {
        message.error(err?.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="login-admin">
      <div className="login-admin-gradient-orb login-admin-gradient-orb-1"></div>
      <div className="login-admin-gradient-orb login-admin-gradient-orb-2"></div>
      <div className="login-admin-gradient-orb login-admin-gradient-orb-3"></div>
      <div className="login-admin-particles">
        {Array.from({ length: 20 }).map((_, i) => (
          <div key={i} className="login-admin-particle" style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 5}s`,
            animationDuration: `${10 + Math.random() * 10}s`,
          }}></div>
        ))}
      </div>
      <div className="login-admin-background-icons">
        <div className="login-admin-icon login-admin-icon-1">
          <FileTextOutlined />
        </div>
        <div className="login-admin-icon login-admin-icon-2">
          <CheckCircleOutlined />
        </div>
        <div className="login-admin-icon login-admin-icon-3">
          <QuestionCircleOutlined />
        </div>
        <div className="login-admin-icon login-admin-icon-4">
          <FormOutlined />
        </div>
        <div className="login-admin-icon login-admin-icon-5">
          <BarChartOutlined />
        </div>
        <div className="login-admin-icon login-admin-icon-6">
          <EditOutlined />
        </div>
        <div className="login-admin-icon login-admin-icon-7">
          <FileTextOutlined />
        </div>
        <div className="login-admin-icon login-admin-icon-8">
          <CheckCircleOutlined />
        </div>
      </div>

      <div className="login-admin-content">
        <div className="login-admin-content-header">
          <Link to="/">
            <span className="login-admin-brand">Survey.hemis.uz</span>
          </Link>
          <h2>Test va sorovnomalar o'tkazish platformasi</h2>
        </div>
        <div className="login-admin-content-form">
          <Form layout="vertical" form={form} onFinish={handleSubmit}>
            <Form.Item
              label="Foydalanuvchi nomi"
              name="login"
              rules={[rules.login]}
            >
              <Input
                placeholder={rules.login.message}
                type="text"
                size="large"
              />
            </Form.Item>

            <Form.Item
              label="Foydalanuvchi paroli"
              name="password"
              rules={[rules.password]}
            >
              <Input.Password
              style={{
                backgroundColor: "transparent",
              }}
                placeholder={rules.password.message}
                type="text"
                size="large"
              />
            </Form.Item>

            <Button
              type="primary"
              size="large"
              className="full-width main-button"
              htmlType="submit"
              loading={loading}
            >
              Kirish
            </Button>
          </Form>
        </div>
      </div>

      <div className="login-admin-footer">
        © {new Date().getFullYear()} Raqamli ta'lim texnologiyalarini rivojlantirish markazi
      </div>
    </div>
  );
}

export default AdminLoginPage;
